import moment from 'moment-timezone'

// utc is epoch number either in number or string
export const dateDisplayFormat = (utc: moment.MomentInput, options?: any) => {
  options = options || {}

  if (options.utc) {
    const browserLocalTZ = moment.tz.guess()
    // console.log('browserLocalTZ', browserLocalTZ)
    // console.log(
    //   "moment.tz(utc, 'UTC').tz(browserLocalTZ).format('LLLL')",
    //   moment.tz(utc, 'UTC').tz(browserLocalTZ).format('LLLL')
    // )
    return moment.tz(utc, 'UTC').tz(browserLocalTZ).format('LLLL')
  }

  if (options.unix) {
    // console.log(`moment(utc, 'x').format('LLLL')`, moment(utc, 'x').format('LLLL'))
    // moment('1663091000000', 'x').format('LLLL') => Tuesday, October 8, 2019 5:23 AM
    return moment(utc, 'x').format('LLLL')
  }

  // console.log(`moment(utc).format('LLLL')`, moment(utc).format('LLLL'))
  return moment(utc).format('LLLL')
}

export const formatDateString = (dateString: string, format: string = 'LLLL') => {
  const browserLocalTZ = moment.tz.guess()
  return moment.tz(dateString, browserLocalTZ).format(format)
}

/**
 *
 * @param {String | Number} ms number of milliseconds in date as string or number
 * @param {Number}  numberOfDays number of days to check against
 */
export const isDateRecentThan = (ms: string | number, numberOfDays: number) => {
  if (typeof ms === 'string') {
    ms = parseInt(ms, 10)
  }
  return (Date.now() - new Date(ms).getTime()) / (1000 * 3600 * 24) <= numberOfDays
}
